import React from 'react';
import './AccountQuotaUsage.css';

export const formatQuotaAmount = (resource = {}) => {
  const unit = resource.unit ? ` ${resource.unit}` : '';
  const limit = resource.unlimited ? 'unlimited' : `${resource.limit ?? '—'}${unit}`;
  const used = resource.tracked ? `${resource.used ?? 0}${unit}` : 'Not tracked';
  return `${used} / ${limit}`;
};

const AccountQuotaUsage = ({ username, quotaUsage }) => {
  const resources = Object.values(quotaUsage?.resources || {});
  const period = quotaUsage?.period;

  if (!resources.length) {
    return <span className="account-quota-unavailable">Unavailable</span>;
  }

  return (
    <div className="account-quota-usage" aria-label={`Quota usage for ${username}`}>
      {period?.label && (
        <small className="account-quota-period">
          {period.label}{period.timezone ? ` · ${period.timezone}` : ''}
        </small>
      )}
      <div className="account-quota-resources">
        {resources.map((resource) => (
          <div className="account-quota-resource" key={resource.label}>
            <span>{resource.label}</span>
            <strong className={resource.tracked ? '' : 'untracked'}>
              {formatQuotaAmount(resource)}
            </strong>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountQuotaUsage;
